import { useNavigate } from "react-router-dom";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";

const COLORS = ["#B22234", "#6366f1", "#0ea5e9", "#f59e0b", "#10b981", "#8b5cf6", "#ec4899", "#14b8a6", "#f97316"];

function CustomTooltip({ active, payload }) {
  if (!active || !payload || !payload[0]) return null;
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-2.5 shadow-xl text-sm">
      <p className="text-slate-700">{payload[0].name}: <span className="font-bold text-slate-900">{payload[0].value}</span></p>
    </div>
  );
}

export default function CategoryChart({ data }) {
  const navigate = useNavigate();

  if (!data || data.length === 0) return null;

  const top8 = data.slice(0, 8);
  const others = data.slice(8);
  const chartData = others.length > 0
    ? [...top8, { name: "Other", value: others.reduce((s, c) => s + c.value, 0) }]
    : top8;

  const handleClick = (entry) => {
    if (entry.name !== "Other") {
      navigate(`/tickets?category=${encodeURIComponent(entry.name)}`);
    }
  };

  return (
    <div className="corp-card animate-fade-slide-up" style={{ animationDelay: "500ms" }} data-testid="category-chart">
      <div className="h-1 w-full bg-[#f59e0b]" />
      <div className="p-6">
        <div className="mb-4">
          <h3 className="text-base font-bold text-slate-800">By Category</h3>
          <p className="text-xs text-slate-400 mt-0.5">Top issue categories</p>
        </div>

        <ResponsiveContainer width="100%" height={200}>
          <PieChart>
            <Pie
              data={chartData}
              cx="50%"
              cy="50%"
              innerRadius={55}
              outerRadius={85}
              paddingAngle={2}
              dataKey="value"
              onClick={handleClick}
              style={{ cursor: 'pointer' }}
            >
              {chartData.map((entry, i) => (
                <Cell key={i} fill={COLORS[i % COLORS.length]} stroke="white" strokeWidth={2} />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
          </PieChart>
        </ResponsiveContainer>

        <div className="mt-3 space-y-0.5 max-h-[180px] overflow-y-auto">
          {chartData.map((item, i) => (
            <div
              key={item.name}
              className="flex items-center justify-between text-sm py-2 px-2 hover:bg-slate-50 rounded-lg cursor-pointer transition-colors"
              onClick={() => handleClick(item)}
            >
              <div className="flex items-center gap-2.5 min-w-0">
                <div className="w-3 h-3 rounded-md flex-shrink-0" style={{ backgroundColor: COLORS[i % COLORS.length] }} />
                <span className="text-slate-600 truncate text-xs font-medium">{item.name}</span>
              </div>
              <span className="text-slate-800 font-bold text-xs ml-2">{item.value}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
